import { useTranslations } from "@fenetech/translations";
import { Grid, Skeleton, Typography } from "@mui/material";
import CheckBoxForm from "components/Common/CheckBoxForm";
import LabeledText from "components/Common/LabeledText";
import { QuoteRequiredFieldEnum } from "helpers/enums";
import React, { useCallback, useMemo } from 'react';
import { useFieldArray, useFormContext } from "react-hook-form";

interface IProps {
    readOnly: boolean,
    termsExist: boolean
}

const CompanyRequiredFields: React.FC<IProps> = ({ readOnly, termsExist }: IProps) => {

    const tm = useTranslations();
    const { control } = useFormContext();

    const { fields } = useFieldArray({
        control: control,
        name: "requiredFields"
    });

    const showSkeleton: boolean = useMemo(() => {
        if (!readOnly) {
            return false;
        }

        if (fields.some(f => f["isRequired"])) {
            return false;
        }
        
        return true;
    }, [readOnly, fields]);

    const isFieldDisabled = useCallback((field: Record<"id", string>) => {
        if (field["enumValue"] === QuoteRequiredFieldEnum.Terms && !termsExist) {
            return true;
        }
        return false;
    }, [termsExist]);

    return <Grid container>
        <Grid item xs={12}>
            <LabeledText
                text=""
                label={tm.Get("Required Quote Fields")} />
        </Grid>
        <Grid item container xs={12}>
        {showSkeleton ?
            <Grid item xs={12} sm={6}>    
                <Typography>
                    <Skeleton width="100%" animation={false} />
                </Typography>
            </Grid>
            :
            <>
                {fields.map((field, index) => {
                    return <Grid item xs={12} key={field.id}>
                        <CheckBoxForm
                            readOnly={readOnly}
                            fieldName={`requiredFields.${index}.isRequired`}
                            label={field["description"]}
                            showHideInsteadOfIcon={true}
                            disabled={isFieldDisabled(field)}
                        />
                    </Grid>
                })}
            </>
        }
        </Grid>
    </Grid>
}

export default CompanyRequiredFields;